class PdpKachingAtc extends HTMLElement {
  constructor() {
    super();
    this.#form = this.querySelector('form');
    this.#submitButton = this.querySelector('[type="submit"]');
    this.#errorNote = this.querySelector('.pdp-kaching-atc__error-note');
    this.#form?.addEventListener('submit', this.#onSubmit.bind(this));
  }

  #form;
  #submitButton;
  #errorNote;

  #onSubmit(evt) {
    evt.preventDefault();

    if (!this.#form || !this.#submitButton) return;
    if (this.#submitButton.disabled || this.#submitButton.getAttribute('aria-disabled') === 'true') return;

    const cartAddUrl = `${window.routes?.cart_add_url || '/cart/add'}.js`;
    const cartUrl = (window.getCartUrl && window.getCartUrl()) || '/cart';
    const formData = new FormData(this.#form);

    this.#setLoading(true);

    fetch(cartAddUrl, {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          this.#showError(data.description || data.message);
          return;
        }

        this.#hideError();

        if (window.onAddToCartSuccess) {
          window.onAddToCartSuccess(cartUrl);
        } else {
          window.location.href = cartUrl;
        }
      })
      .catch(() => {
        this.#showError('Error adding to cart. Please try again.');
      })
      .finally(() => {
        this.#setLoading(false);
      });
  }

  #setLoading(isLoading) {
    if (!this.#submitButton) return;

    this.#submitButton.toggleAttribute('disabled', isLoading);
    this.#submitButton.setAttribute('aria-disabled', isLoading ? 'true' : 'false');
    this.#submitButton.classList.toggle('loading', isLoading);
  }

  #showError(message) {
    if (!this.#errorNote) {
      window.alert(message);
      return;
    }

    this.#errorNote.textContent = message;
    this.#errorNote.style.display = '';
  }

  #hideError() {
    if (!this.#errorNote) return;
    this.#errorNote.style.display = 'none';
  }
}

if (!customElements.get('pdp-kaching-atc')) {
  customElements.define('pdp-kaching-atc', PdpKachingAtc);
}
